import { Injectable } from '@angular/core';
import { ConfigDataStoreService } from './config-data-store.service';
import { InternationalSearchAuthority } from '../../../shared/dto/system-config/international-search-authority';
import { ConfigService } from '../../config.service';
import { UserService } from '../../../shared/services/user.service';
import { SystemConfigDTO } from '../../../shared/dto/system-config/system-config-dto';
import { SystemConfigResponseDTO } from '../../../shared/dto/system-config/system-config-response-dto';

@Injectable()
export class IntSearchAuthorityDataStoreService extends ConfigDataStoreService<InternationalSearchAuthority> {

  constructor(configService: ConfigService, userService: UserService) {
    super(configService, userService, 'INTERNATIONAL_SEARCH_AUTHORITY');
  }

  public create(data: InternationalSearchAuthority): Promise<SystemConfigResponseDTO> {
    const configObject: SystemConfigDTO = { userId: this.user.id, type: this.type, searchAuthorityDTO: data };
    const response = this.configService.addSystemConfig(configObject);
    response.then(res => {
      this.dataSetPromise.then(dataSet => {
        dataSet.push(res.configValueDTO as InternationalSearchAuthority);
        this.dataSet.next(dataSet);
        this.dataSetPromise = Promise.resolve(dataSet);
      });
    });

    return response;
  }

  public update(data: InternationalSearchAuthority): Promise<SystemConfigResponseDTO> {
    const configObject: SystemConfigDTO = { userId: this.user.id, type: this.type, searchAuthorityDTO: data };
    const response = this.configService.updateSystemConfig(configObject);
    response.then(res => {
      this.dataSetPromise.then(dataSet => {
        const index = dataSet.findIndex(dataPoint => dataPoint.id === res.configValueDTO.id);
        dataSet[index] = res.configValueDTO as InternationalSearchAuthority;
        this.dataSet.next(dataSet);
        this.dataSetPromise = Promise.resolve(dataSet);
      });
    });

    return response;
  }

  public enable(data: InternationalSearchAuthority): Promise<SystemConfigResponseDTO> {
    return this.configService.enableSystemConfig({ userId: this.user.id, type: this.type, searchAuthorityDTO: data });
  }

  public disable(data: InternationalSearchAuthority): Promise<SystemConfigResponseDTO> {
    return this.configService.disableSystemConfig({ userId: this.user.id, type: this.type, searchAuthorityDTO: data });
  }
}
